if(customElements.get('wiro-modal') === undefined) {
  class WiroModal extends HTMLElement {
    constructor() {
        super();
        // Create shadow DOM for modal
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = `
            <style>
                .wiro-modal {
                    display: none;
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.2);
                    z-index: 9999;
                }
                .wiro-modal__content {
                    position: relative;
                    background: #FAF7F1;
                    margin: auto;
                    padding: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 1;
                    max-width: 760px;
                    box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.16);
                }
                .wiro-modal__header {
                    position: absolute;
                    top: 24px;
                    right: 24px;
                    font-size: 28px;
                    line-height: 28px;
                    cursor: pointer;
                    color: black;
                }
            </style>

            <div class="wiro-modal">
                <div class="wiro-modal__content">
                    <div class="wiro-modal__header">
                        <span class="wiro-modal__close">&times;</span>
                    </div>
                    <div class="wiro-modal__body">
                        <slot><slot>
                    </div>
                </div>
            </div>
        `;
    }

    // --- LIFECYCLE ---

    connectedCallback() {
        this.modalEL = this.shadowRoot.querySelector(".wiro-modal");
        if(this.dataset.name) this.triggers = [...document.querySelectorAll(`[data-target="${this.dataset.name}"]`)];
        if(this.triggers?.length) this.triggers.forEach(t => t.addEventListener('click', this.showModal.bind(this)));
        this.shadowRoot.querySelector(".wiro-modal__close").addEventListener('click', this.hideModal.bind(this));
    }
    disconnectedCallback() {
        if(this.triggers?.length) this.triggers.forEach(t => t.removeEventListener('click', this.showModal));
        this.shadowRoot.querySelector(".wiro-modal__close").removeEventListener('click', this.hideModal);
    }

    // --- METHODS ---

    showModal() {
        this.isModalVisible = true;
        this.modalEL.style.display = 'block';
    }
    hideModal() {
        this.isModalVisible = false;
        this.modalEL.style.display = 'none';
    }
  }
  customElements.define('wiro-modal', WiroModal);
}
